// @ts-ignore
//import axios from 'axios';
import { logout } from "../backend/backend.service";
import store from "../../store";
import {
  removeToken,
  removeUserId,
  removeUsername,
  removeLanguageId,
  removeSchemaId,
  removeMenuId,
} from "../storage/storage.service";


export async function deauthenticate() {
  const response = await logout();
  removeToken();
  removeUsername();
  removeUserId();
  removeLanguageId();
  removeSchemaId();
  removeMenuId();
  // @ts-ignore
  store.dispatch("fetchAuthentication", false);
  // @ts-ignore
  store.dispatch("fetchSecret", undefined);
  // @ts-ignore
  store.dispatch("fetchPermissions", []);
  const userManagement = {
    "users": [],
    "admins": [],
    "access_levels": [],
    "staffs": [],
    "students": [],
    "roles": [],
    "permissions": []
  };
  store.dispatch("fetchUserManagement", userManagement);
  if (response.message == "Logout successful") {
    if(window.location.pathname.includes("eagente")) {
      window.location.href = "/iam?eagente";
    } else {
    window.location.href = "/iam";
    }
  }
}
